<div class="add-page">
  <div class="add-page__header">
    <div class="header-link-block">
      <a routerLink="/page/books-list" class="header-link">Books</a>
      <span> > </span>
      <span>{{
        state.isAdd
        ? "Add Book Info"
        : state.isEdit
        ? "Edit Book Info"
        : state.isView
        ? "View Book Info"
        : ""
        }}</span>
    </div>
    <div
        (click)="onEditClick()"
        [ngStyle]="{ display: state.isAdd ? 'none' : '' }"
        [ngClass]="
                   state.isEdit && !state.isAdd ? 'edit-block' : 'view-edit-block'
                   "
        >
        <svg
            *ngIf="!state.isAdd || state.isEdit"
            viewBox="0 0 24 24"
            [ngClass]="state.isEdit ? 'edit-icon' : 'view-edit-icon'"
            >
            <g id="XMLID_1_">
            <path
                d="m22.06 7.6-14 13.99c.2-.19.2-.51 0-.7l-.35-.35 13.29-13.3-.35-.35c.09.09.22.15.35.15s.26-.06.35-.15l.36-.35.35.35c.19.19.19.51 0 .71z"
                />
            <path
                d="m23.12 5.12-1.41 1.42-.71-.71 1.41-1.42c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.41c-.77-.78-2.05-.78-2.82 0l-1.42 1.41-.7-.7 1.41-1.42c1.17-1.17 3.07-1.17 4.24 0 .57.57.88 1.32.88 2.12s-.31 1.55-.88 2.12z"
                />
            <path
                d="m21 5.83.71.71-.36.35c-.09.09-.22.15-.35.15s-.26-.06-.35-.15l-3.54-3.54c-.19-.19-.19-.51 0-.7l.36-.35.7.7z"
                />
            <path
                d="m15.69 3.35-.35-.35 1.06-1.06c.19-.19.52-.19.71 0l.36.36-.36.35c-.19.19-.19.51 0 .7l-.35-.35-1.06 1.07-.01-.01c.2-.19.2-.51 0-.71z"
                />
            <path
                d="m15.34 3 .35.35c.2.2.2.52 0 .71-.19.2-.51.2-.7 0l-.35-.35z"
                />
            <path d="m7.9 21.7c.06-.02.12-.06.16-.11-.04.05-.1.08-.16.11z" />
            <path
                d="m7.71 21.74c-.13 0-.26-.05-.35-.15l-.58-.58.67-.21.26-.26.35.35c.2.19.2.51 0 .7-.04.05-.1.09-.16.11-.06.03-.12.04-.19.04z"
                />
            <path
                d="m12.16 3.35-4.95 4.95c-.1.1-.22.15-.35.15s-.26-.05-.36-.15c-.19-.19-.19-.51 0-.7l4.95-4.95c.95-.95 2.6-.95 3.54 0l.35.35-.7.71-.36-.36c-.56-.56-1.55-.56-2.12 0z"
                />
            <path d="m3.47 16.29 4.24 4.25-.26.26-.67.21-3.79-3.79.21-.66z" />
            <path
                d="m3.2 16.56-.21.66-.58-.58c-.15-.14-.19-.36-.11-.54.02-.06.06-.11.11-.16.19-.2.51-.2.71 0l.35.35z"
                />
            <path
                d="m15.7 4.07-12.23 12.22-.35-.35c-.2-.2-.52-.2-.71 0l12.23-12.23.35.35c.19.2.51.2.7 0z"
                />
            <path d="m2.41 15.94c-.05.05-.09.1-.11.16.03-.06.06-.12.11-.16z" />
            <path
                d="m7.86 21.72-7.21 2.26c-.05.01-.1.02-.15.02-.13 0-.26-.05-.35-.15-.14-.13-.18-.32-.13-.5l2.26-7.21c.01-.01.01-.03.02-.04-.08.18-.04.4.11.54l.58.58-1.73 5.52 5.52-1.73.58.58c.09.1.22.15.35.15.07 0 .13-.01.19-.04-.01.01-.03.01-.04.02z"
                />
            </g>
        </svg>
    </div>
  </div>
  <div class="add-page__content">
    <input-cmp
        class="title-input"
        [inputText]="title"
        isAdd="true"
        placeholder="Title"
        [isEdit]="state.isEdit"
        (output)="setTitle($event)"
        ></input-cmp>

    <input-cmp
        class="description-input"
        [inputText]="description"
        [isEdit]="state.isEdit"
        isSlokaTypeTextArea="true"
        placeholder="Description"
        (output)="setDescription($event)"
        ></input-cmp>

    <input-cmp
        class="title-input"
        [inputText]="noOfPages"
        isAdd="true"
        placeholder="No of Pages"
        [isEdit]="state.isEdit"
        (output)="setNoOfPages($event)"
        ></input-cmp>

    <input-cmp
        class="title-input"
        [inputText]="actualPrice"
        isAdd="true"
        placeholder="Actual Price"
        [isEdit]="state.isEdit"
        (output)="setActualPrice($event)"
        ></input-cmp>

    <input-cmp
        class="title-input"
        [inputText]="discountedPrice"
        isAdd="true"
        placeholder="Discounted Price (Opt.)"
        [isEdit]="state.isEdit"
        (output)="setDiscountedPrice($event)"
        ></input-cmp>

    <input-cmp
        class="title-input"
        [inputText]="buyingLinkShop"
        isAdd="true"
        placeholder="Book Selling Site Name"
        [isEdit]="state.isEdit"
        (output)="setBuyingLinkShop($event)"
        ></input-cmp>

    <input-cmp
        class="title-input"
        [inputText]="buyingLink"
        isAdd="true"
        placeholder="Book Buying Link"
        [isEdit]="state.isEdit"
        (output)="setBuyingLink($event)"
        ></input-cmp>

    <div class="view-image-block" *ngIf="state.isView || state.isEdit">
      <input-cmp
          class="view-image"
          placeholder="Uploaded Images"
          [isViewImage]="isViewImage"
          [imageLink]="state?.data?.imageUrls"
          [isMultiple]="true"
          [isEdit]="state.isEdit"
          (imageDeleteOutput)="onImageDelete($event)"
          ></input-cmp>
    </div>

    <div *ngFor="let number of filesCount">
      <input-cmp
          *ngIf="!state.isView"
          isUpload="true"
          placeholder="Upload Image"
          (output)="imageFileOutput($event)"
          ></input-cmp>
    </div>

    <div *ngIf="state.isEdit || state.isAdd">
    <button class="add-image-button" (click)="onAddAnotherImage($event)">
      + Add Image
    </button>
    </div>

  </div>
  <div
      [ngClass]="!state.isView ? 'add-page__buttons' : 'add-page__view-buttons'"
      >
      <button-cmp
          isLogin="false"
          isAdd="false"
          isCancel="false"
          [title]="!state.isAdd ? 'Update' : 'Add'"
          (click)="state.isAdd ? onAddClick() : onUpdateClick()"
          *ngIf="!state.isView"
          ></button-cmp>
      <button-cmp
          routerLink="/page/books-list"
          isLogin="false"
          isAdd="false"
          isCancel="true"
          title="Cancel"
          ></button-cmp>
  </div>
</div>
